import Link from 'next/link';
import cx from 'classnames';
import { getArticleCollectPageUrl } from 'src/services/pagesUrl/getArticleCollectPageUrl';
import { linkHoverClassNames } from 'utils/linkHoverClassNames';
import { CollectIcon } from '../Icons/CollectIcon';
import Typo from '../Typography';

type TArticleHeaderInfoToolbarCollectProps = {
  totalMinted: number;
  articleSlug: string;
};

export const ArticleHeaderInfoToolbarCollect = ({
  totalMinted,
  articleSlug,
}: TArticleHeaderInfoToolbarCollectProps) => (
  <Link
    href={getArticleCollectPageUrl(articleSlug)}
    className={cx('group flex items-center gap-2', linkHoverClassNames)}
  >
    <CollectIcon className="group-hover:fill-t2-primary-brandColor" />
    <Typo>{Number(totalMinted || 0).toString()}</Typo>
  </Link>
);
